var map = {
	"./chapterPhotos/geschichte/breslau-kommers.jpg": "65be",
	"./chapterPhotos/geschichte/grundung-1.jpg": "b6b2",
	"./chapterPhotos/geschichte/grundung-2.jpg": "ff42",
	"./chapterPhotos/geschichte/grundung-3.jpg": "e958",
	"./chapterPhotos/geschichte/merk-leute.jpg": "d923",
	"./chapterPhotos/geschichte/merk-poster.jpg": "bc7e",
	"./chapterPhotos/uber-uns/amicitia-old.jpg": "16c5",
	"./chapterPhotos/uber-uns/amicitia.jpg": "bde6",
	"./chapterPhotos/uber-uns/cathedral.jpg": "cacc",
	"./chapterPhotos/uber-uns/oppeln.jpg": "31fe",
	"./chapterPhotos/uber-uns/schlesien-karte.jpg": "7da8",
	"./chapterPhotos/uber-uns/technische-universitat.jpg": "f85b",
	"./chapterPhotos/zimmer-frei/zimmer-frei-1.jpg": "01c2",
	"./chapterPhotos/zimmer-frei/zimmer-frei-2.jpg": "6ae4",
	"./chapterPhotos/zimmer-frei/zimmer-frei-3.jpg": "f26d",
	"./chapterPhotos/zimmer-frei/zimmer-frei-4.jpg": "fe17",
	"./chapterPhotos/zimmer-frei/zimmer-frei-5.jpg": "74e5",
	"./chapterPhotos/zimmer-frei/zimmer-frei-6.jpg": "26fa",
	"./chapterPhotos/zimmer-frei/zimmer-frei-7.jpg": "c76e",
	"./chapterPhotos/zimmer-frei/zimmer-frei-8.jpg": "35c6",
	"./external-articles/dfk-lubowice-35-anniversary.jpg": "4705",
	"./external-articles/spectrum-article.jpg": "db78",
	"./external-articles/wochenblatt-33-jahre.jpg": "c039",
	"./external-articles/wochenblatt-article.jpg": "0d55",
	"./external-articles/wochenblatt-freies-denken.jpg": "d4e6",
	"./external-articles/wochenblatt-pilgrim.jpg": "f76b",
	"./external-articles/wochenblatt-rheno-palatia.jpg": "5718",
	"./external-articles/wochenblatt-schlesien-herzen.jpg": "0957",
	"./hauptseite-old/haus-salia.jpg": "ead3",
	"./hauptseite-old/old-salia.jpg": "536a",
	"./hauptseite-old/publikationfest.jpg": "059b",
	"./hauptseite-old/salia-wappen.jpg": "16b1",
	"./hauptseite-old/salia.jpg": "50b3",
	"./hauptseite-old/semesterprogramm.jpg": "89f2",
	"./hauptseite-old/zimmer-frei.jpg": "ae0f",
	"./hauptseite/hauptseite-geschichte.jpg": "2f77",
	"./hauptseite/hauptseite-kontakt.jpg": "7365",
	"./hauptseite/hauptseite-unsere-prinzipien.jpg": "f15e",
	"./hauptseite/hauptseite-willkommen.jpg": "e4a3",
	"./hauptseite/hauptseite-zimmer-frei.jpg": "e5be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "25ca";